import React, { useEffect, useRef, useState } from "react";
import ConfirmModal from "../../../components/comman/ConfirmModal";
import CommonTable from "../../../components/comman/CommonTable";
import TopLable from "../../../components/comman/TopLable";
import MainHeading from "../../../components/comman/MainHeading";
import EditIcon from "../../../components/Icons/EditIcon";
import DeleteIcon from "../../../components/Icons/DeleteIcon";
import { apiUrl } from "../../../ApiHelper/ApiUrl";
import { callApi } from "../../../ApiHelper/ApiHelper";
import { toast } from "react-toastify";
import { MainFilterHandler } from "../../../components/comman/MainFilterHandler";
import moment from "moment";
import ViewIcon from "../../../components/Icons/ViewIcon";
import { useNavigate } from "react-router-dom";
import FilterComponent from "../../../components/comman/FilterComponent";
import PlusIcon from "../../../components/Icons/PlusIcon";
import { RoutesLink } from "../../../ApiHelper/RoutesLink";
import { useDispatch, useSelector } from "react-redux";
import { updateFiltersStates } from "../../../store/actions/UserActions";

export default function UserOd() {
  const [modal, setModal] = useState({
    updateData: false,
    deleteData: false,
  });
  const [state, setState] = useState({
    OdList: [],
    EditData: null,
  });
  const [selectedId, setSelectedId] = useState("");
  const navigate = useNavigate();
  const timeoutId = useRef(null);
  const dispatch = useDispatch();
  const filterDetails = useSelector((state) => state.root.filtersStates);
  const [pageStates, setPageStates] = useState({
    currentPage: 1,
    pageSize: 10,
    count: 0,
    totalPages: 0,
    tableLoader: false,
    filterData: "",
    searchQuery: "",
    sortByDate: [
      moment().subtract(1, "month").format("YYYY-MM-DD"),
      moment().format("YYYY-MM-DD"),
    ],
  });
  const [isLoading, setIsLoading] = useState(false);

  const toggleModal = (type) => {
    setModal((pre) => ({
      ...pre,
      ...(type === "delete"
        ? { deleteData: !pre.deleteData }
        : { updateData: !pre.updateData }),
    }));
  };

  const getMyOdReq = (pageNo) => {
    let options = {
      method: "GET",
    };
    const Url =
      apiUrl.get_od +
      MainFilterHandler({ ...pageStates, orderBy: filterDetails?.orderBy }) +
      "&myOdrequest=true";
    setPageStates((pre) => ({
      ...pre,
      tableLoader: !pre.tableLoader,
    }));
    callApi(Url, options).then((res) => {
      setPageStates((pre) => ({
        ...pre,
        tableLoader: !pre.tableLoader,
      }));
      if (res?.status === true) {
        const newData = res?.data?.odRequest?.map((item) => ({
          ...item,
          appliedDate: moment(item?.createdAt).format("DD/MM/YYYY"),
          checkInTime1: moment(item?.startDate).format("DD-MM-YYYY"),
          checkOutTime1: moment(item?.endDate).format("DD-MM-YYYY"),
          checkInType: item?.visit,
          reasonOd: item?.reason,
          odStatus: item?.status,
        }));
        setState((pre) => ({
          ...pre,
          OdList: newData,
        }));
        setPageStates((pre) => ({
          ...pre,
          count: res?.data?.pageInfo?.total,
          totalPages: res?.data?.pageInfo?.totalPages,
        }));
      }
    });
  };

  const TableHeading = [
    { value: "index", label: "SR NO." },
    { value: "appliedDate", label: "Applied Date" },
    { value: "checkInType", label: "Check-In Type" },
    { value: "checkInTime1", label: "Start Date" },
    { value: "checkOutTime1", label: "End Date" },
    { value: "reasonOd", label: "Reason" },
    { value: "odStatus", label: "Status" },
  ];

  const PageChangeHandler = (PageNo) => {
    // console.log("PageChangeHandler", PageNo);
    if (PageNo > 0 && PageNo <= pageStates?.totalPages) {
      setPageStates((prev) => ({
        ...prev,
        currentPage: PageNo,
      }));
    }
  };

  const handleChangePageSize = (value) => {
    setPageStates((prev) => ({
      ...prev,
      pageSize: value,
      currentPage: 1,
    }));
  };

  const handleSearchChange = (e) => {
    const { value } = e.target;
    if (timeoutId.current) {
      clearTimeout(timeoutId.current);
    }
    timeoutId.current = setTimeout(() => {
      setPageStates((prevState) => ({
        ...prevState,
        currentPage: 1,
        searchQuery: value,
      }));
    }, 300);
  };

  useEffect(() => {
    getMyOdReq();
  }, [
    pageStates?.sortByDate,
    pageStates?.searchQuery,
    pageStates.currentPage,
    pageStates.pageSize,
    filterDetails?.orderBy,
  ]);

  const handleEdit = (data) => {
    // if (isEndDateGreater(data?.checkOutTime)) {
    navigate(RoutesLink.add_Od_request, { state: { EditOdData: data } });
    // } else {
    //     toast.error('Can not update past leave request.');
    // }
  };

  const ActionHandler = (data) => {
    navigate(`${RoutesLink?.od_request_detail}/${data?.id}`);
  };

  const DeleteHandler = (data) => {
    setSelectedId(data?.id);
    toggleModal("delete");
  };

  const HandleDelete = () => {
    let options = {
      method: "GET",
    };
    let API = apiUrl.delete_Od + `?odRequestId=${selectedId}`;
    setIsLoading(true);
    callApi(API, options).then((response) => {
      setIsLoading(false);
      if (response?.status === true) {
        toast.success(response?.message);
        toggleModal("delete");
        getMyOdReq();
      } else {
        toast.error(response?.message);
        toggleModal("delete");
      }
    });
  };

  const ActionData = [
    {
      label: "View",
      className: "btn btn-link",
      icon: <ViewIcon />,
      title: "view",
      isShow: "always",
      clickHandler: ActionHandler,
    },
    {
      label: "Edit",
      className: "btn btn-link",
      icon: <EditIcon />,
      title: "edit",
      isShow: 0,
      clickHandler: handleEdit,
    },
    {
      label: "Delete",
      className: "btn btn-link",
      icon: <DeleteIcon />,
      title: "delete",
      isShow: 0,
      clickHandler: DeleteHandler,
    },
  ];

  const dateChangeHandler = (Dates) => {
    // console.log(Dates);
    let formattedDate = null;
    if (Dates && Dates.length === 2) {
      const startDate = new Date(
        Dates[0].getTime() - Dates[0].getTimezoneOffset() * 60000
      )
        .toISOString()
        .slice(0, 10);
      const endDate = new Date(
        Dates[1].getTime() - Dates[1].getTimezoneOffset() * 60000
      )
        .toISOString()
        .slice(0, 10);
      formattedDate = [startDate, endDate];
    }
    // console.log(formattedDate);
    if (formattedDate !== null) {
      setPageStates((prevState) => ({
        ...prevState,
        sortByDate: formattedDate,
      }));
    } else {
      setPageStates((prevState) => ({ ...prevState, sortByDate: "" }));
    }
  };

  const orderByHandler = (e) => {
    dispatch(
      updateFiltersStates({
        orderBy: e.target.value,
      })
    );
  };

  const orderByList = [
    { value: "", name: "Newest" },
    { value: "asc", name: "Oldest" },
  ];

  return (
    <>
      <div className="content">
        <MainHeading
          title={"Outdoor Duty Request"}
          buttonText={"Apply O.D. Request"}
          buttonIcon={<PlusIcon />}
          buttonLink={RoutesLink?.add_Od_request}
          dateChangeHandler={dateChangeHandler}
        // clickHandler={toggleModal}
        />
        {/* <TopLable items={topLabelItems} /> */}
        <div className="card mb-4">
          <div className="card-body">
            <FilterComponent
              // handleFilterForLeave={setPageStates}
              handleSearch={handleSearchChange}
              orderByHandler={orderByHandler}
              orderByList={orderByList}
            />
            <CommonTable
              TableHeading={TableHeading}
              TableData={state?.OdList}
              ActionData={ActionData}
              currentPage={pageStates?.currentPage}
              PageChangeHandler={PageChangeHandler}
              isLoading={pageStates?.tableLoader}
              totalPages={pageStates?.totalPages}
              count={pageStates?.count}
              handleChangePageSize={handleChangePageSize}
              pageSize={pageStates.pageSize}
            />
          </div>
        </div>
      </div>
      <ConfirmModal
        modal={modal.deleteData}
        toggle={() => toggleModal("delete")}
        submitHandler={HandleDelete}
        isLoading={isLoading}
      />
    </>
  );
}
